import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import { getRequestTypeTitle, renderRequestLink } from "helpers/RequestHelper";
import { formatDate } from "helpers/DateHelper";
import NoTableData from "components/NoTableData";

const ModelVersions = ({ tableData, showLink }) => {
  if (tableData.length) {
    const renderRows = () => {
      return tableData.map((row, i) => {
        const {
          hwversion,
          swversion,
          id,
          formatedtransactionnumber,
          requesttypeid,
          completedat
        } = row;
        const reqType = getRequestTypeTitle(requesttypeid);
        const certDate = formatDate(completedat);
        return (
          <tr key={i}>
            <td>
              {renderRequestLink(id, formatedtransactionnumber, showLink)}
            </td>
            <td>{hwversion}</td>
            <td>{swversion}</td>
            <td>{reqType}</td>
            <td>{certDate}</td>
          </tr>
        );
      });
    };

    return (
      <div>
        <h3>Device History</h3>
        <Table responsive striped>
          <thead>
            <tr>
              <th>Request Id</th>
              <th>HW Version</th>
              <th>SW Version</th>
              <th>Request Type</th>
              <th>Date Certified</th>
            </tr>
          </thead>
          <tbody>{renderRows()}</tbody>
        </Table>
      </div>
    );
  }

  return <NoTableData />;
};

ModelVersions.propTypes = {
  tableData: PropTypes.array,
  showLink: PropTypes.bool
};

ModelVersions.defaultProps = {
  tableData: [],
  showLink: false
};

export default ModelVersions;



// WEBPACK FOOTER //
// ./src/containers/Devices/ModelVersions.js